import axios from "axios";
import ApiConfig from "../config/ApiConfig";
import { toast } from "react-toastify";
import { STATUS_200, STATUS_300 } from "../data/constants";
import { errorMessage } from "../lib/helper";
import { setHomeData,setHomeDataError,setLoading, setTechincalHorizontalData, setTechincalHorizontalDataLoading, setTechincalVerticalData, setTechincalVerticalDataLoading, setTechinicalHorizontalDataError, setTechinicalVerticalDataError } from "../redux/cmsData";

export const GetAllCMSData = (payload,setState,setErrorState) => {
  //get(`${ApiConfig.getCmsData}`, {params:payload})
  return async (dispatch) => {
    try {
      dispatch(setLoading(true));
      const resp = await axios.get(`${ApiConfig.getCMSdata}`,{params:payload});
      if (resp?.data?.status >= STATUS_200 && resp?.data?.status < STATUS_300) { 
         dispatch(setState(resp?.data?.data));
        dispatch(setLoading(false));
      } else {
        throw resp;
      }
    } catch (e) {
      dispatch(
        setErrorState({
          isError: true,
          message: errorMessage(e),
        })
      );
      toast.error(errorMessage(e), {
        autoClose: 2500,
      });
      dispatch(setLoading(false));
    }
  };
};

export const GetTableCMSData = (endPoint, payload,setState,setLoadingState,setErrorState) => {
  return async (dispatch) => {
    try {
      dispatch(setLoadingState(true));
      const resp = await axios.get(`${ApiConfig[endPoint]}`,{params:payload});
      if (resp?.data?.status >= STATUS_200 && resp?.data?.status < STATUS_300) { 
         dispatch(setState(resp?.data?.data));
        dispatch(setLoadingState(false));
      } else {
        throw resp;
      }
    } catch (e) {
      dispatch(
        setErrorState({
          isError: true,
          message: errorMessage(e),
        })
      );
      toast.error(errorMessage(e), {
        autoClose: 2500,
      });
      dispatch(setLoadingState(false));
    }
  };
};


export const GetAllCMSTestimonialData = (payload,setState,setErrorState) => {
  //get(`${ApiConfig.getCmsData}`, {params:payload})
  return async (dispatch) => {
    try {
      dispatch(setLoading(true));
      const resp = await axios.get(`${ApiConfig.listOfTestimonial}`,{params:payload});
      if (resp?.data?.status >= STATUS_200 && resp?.data?.status < STATUS_300) { 
         dispatch(setState(resp?.data?.data));
        dispatch(setLoading(false));
      } else {
        throw resp;
      }
    } catch (e) {
      dispatch(
        setErrorState({
          isError: true,
          message: errorMessage(e),
        })
      );
      toast.error(errorMessage(e), {
        autoClose: 2500,
      });
      dispatch(setLoading(false));
    }
  };
};

export const GetHorizonatlTechnicalData = (payload) => {
  //get(`${ApiConfig.getCmsData}`, {params:payload})
  return async (dispatch) => {
    try {
      dispatch(setLoading(true));
      const resp = await axios.post(`${ApiConfig.listOfHorizontalAndVerticalImage}`,payload);
      if (resp?.data?.status >= STATUS_200 && resp?.data?.status < STATUS_300) { 
         dispatch(setTechincalHorizontalData(resp?.data?.data));
        dispatch(setTechincalHorizontalDataLoading(false));
      } else {
        throw resp;
      }
    } catch (e) {
      dispatch(
        setTechinicalHorizontalDataError({
          isError: true,
          message: errorMessage(e),
        })
      );
      toast.error(errorMessage(e), {
        autoClose: 2500,
      });
      dispatch(setTechincalHorizontalDataLoading(false));
    }
  };
};
export const GetVerticalTechnicalData = (payload) => {
  //get(`${ApiConfig.getCmsData}`, {params:payload})
  return async (dispatch) => {
    try {
      dispatch(setLoading(true));
      const resp = await axios.post(`${ApiConfig.listOfHorizontalAndVerticalImage}`,payload);
      if (resp?.data?.status >= STATUS_200 && resp?.data?.status < STATUS_300) { 
         dispatch(setTechincalVerticalData(resp?.data?.data));
        dispatch(setTechincalVerticalDataLoading(false));
      } else {
        throw resp;
      }
    } catch (e) {
      dispatch(
        setTechinicalVerticalDataError({
          isError: true,
          message: errorMessage(e),
        })
      );
      toast.error(errorMessage(e), {
        autoClose: 2500,
      });
      dispatch(setTechincalVerticalDataLoading(false));
    }
  };
};

export const GetBannersData = (setState,setErrorState) => {
  //get(`${ApiConfig.getCmsData}`, {params:payload})
  return async (dispatch) => {
    try {
      dispatch(setLoading(true));
      const resp = await axios.get(`${ApiConfig.bannersList}`);
      if (resp?.data?.status >= STATUS_200 && resp?.data?.status < STATUS_300) { 
         dispatch(setState(resp?.data));
         dispatch(setLoading(false));
      } else {
        throw resp;
      }
    } catch (e) {
      dispatch(
        setErrorState({
          isError: true,
          message: errorMessage(e),
        })
      );
      toast.error(errorMessage(e), {
        autoClose: 2500,
      });
      dispatch(setLoading(false));
    }
  };
};


export const DownloadZip= (payload) => {
  //get(`${ApiConfig.getCmsData}`, {params:payload})
  return async (dispatch) => {
    try {
      dispatch(setLoading(true));
      const resp = await axios.post(`${ApiConfig.sampleImageDownloadNew}`,payload);
      if (resp?.data?.status >= STATUS_200 && resp?.data?.status < STATUS_300) { 
        
      } else {
        throw resp;
      }
    } catch (e) {
     
      toast.error(errorMessage(e), {
        autoClose: 2500,
      });
     
    }
  };
};


